import React from 'react';

const notes = `how many pixels to skip when creating the palette. Default is 10. Less is better, but slower.
By adjusting the sample interval, you can either produce extremely high-quality images slowly, or produce good images in reasonable times.
With a sampleInterval of 1, the entire image is used in the learning phase, while with an interval of 10,
a pseudo-random subset of 1/10 of the pixels are used in the learning phase. A sampling factor of 10 gives a
substantial speed-up, with a small quality penalty.
`;


export default function Doc () {
  return (<div className="" role="">
    
    
  </div>
  )
}
